import { DeliveryRequest } from '../../../../app/models/deliveryRequest';
import { v4 as uuid } from 'uuid';
import { Orders } from '../../../../app/models/orders';
import { store } from '../../../../app/stores/store';
import { initialOutwardState } from '../../../../app/models/outwards';
import { Activity } from '../../../../app/models/activity';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import agent from '../../../../app/api/agent';

function CreateOrderSaveDelivery(
  orderState: Orders,
  deliveryData: DeliveryRequest,
  itemLevel: Activity,
  TemplateData: any,
  currenTaskData: string,
  currentSubTaskData: string,
  sectionModel?: string,
) {
  const deliveryArr = {
    ...deliveryData,
    isOrderCreated: true,
    // isActive:true
  };
  const updateDatas = {
    ...orderState,
    orderId: uuid(),
    orderDateTime: store.activityStore.updateDateTime(),
    departmentId: orderState.departmentId,
    departmentName: store.activityStore.createOrderDepartmentName,
    isReceiving: false,
    isDelivery: true,
    isReturn: false,
    username:
      store.userStore.user?.username !== undefined
        ? store.userStore.user.username
        : '',
    isActive: true,
    itemOrderDelivery: [
      {
        ...initialOutwardState,
        id: uuid(),
        isActive: true,
        customerId: orderState.customerId,
        departmentId: orderState.departmentId,
        deliveryWorkflows: [TemplateData],
      },
    ],
  };
  const DeliveryRequestActArr = {
    ...itemLevel,
    isReceiving: true,
    asset_tracking_status: 'Delivery Order Created',
    movementdate: new Date().toISOString(),
    itemDeliveryRequest: [deliveryArr],
    assignedUsers: [],
  };
  const ActArr = {
    ...itemLevel,
    isReceiving: true,
    asset_tracking_status: 'Delivery Order Created',
    current_task: currenTaskData,
    current_subtask: currentSubTaskData,
    departmentId: orderState.departmentId,
    departmentName: store.activityStore.createOrderDepartmentName,
    movementdate: new Date().toISOString(),
    itemDeliveryRequest: [deliveryArr],
    assignedUsers: [],
    orders: [updateDatas],
  };

  const p1 = new Promise(async (resolve) => {
    store.OrderStore.createOrder(ActArr, TemplateData.templateId, 'Delivery');
    resolve('');
  });
  p1.then(() => {
    setTimeout(async () => {
      if (sectionModel) return;
      store.activityStore.updateActivityProcessDelivery(deliveryArr);
    }, 500);
  });
  p1.then(async () => {
    if (sectionModel) return;
    store.DeliveryStore.createOrderRegister.delete(ActArr.id);
    // await agent.Reports.postItemIDCreateOrderDelivery(itemLevel.id);
  });
  p1.then(async () => {
    if (sectionModel) return;
    const historyMsg = `Outward Process Instructions created successfully for ${DeliveryRequestActArr.title}`;
    await agent.InventoryDelivery.OrderTrackingStatus(
      store.activityStore.selectedActivity?.id,
      'Asset received to unvault',
    );
    store.commonStore.updateHistoryAlonePOST(
      historyMsg,
      ActArr?.id,
      undefined,
      true,
      true,
    );
    sendRespectiveEmail(
      'Notification',
      DeliveryRequestActArr.title,
      'Created Delivery Outward Process Instructions',
      '',
      `${DeliveryRequestActArr.type} is tagged successfully on`,
    );
  });
}

export default CreateOrderSaveDelivery;
